import {AfterViewInit, Component, NgZone, OnInit} from '@angular/core';
import * as am4core from '@amcharts/amcharts4/core';
import am4themes_animated from '@amcharts/amcharts4/themes/animated';
import * as am4charts from '@amcharts/amcharts4/charts';

@Component({
  selector: 'app-chart-cfm',
  templateUrl: './chart-cfm.component.html',
  styleUrls: ['./chart-cfm.component.css']
})
export class ChartCfmComponent implements OnInit, AfterViewInit {

  constructor(private zone: NgZone) { }

  ngOnInit() {
  }

  ngAfterViewInit() {
    this.createCharts();
  }

  createCharts() {
    console.log('cfm');
    this.zone.runOutsideAngular(() => {
      const chart = am4core.create('chart-cfm', am4charts.XYChart);

      chart.data = [
        { x: 1, y: 10 },
        { x: 2, y: 30 },
        { x: 3, y: 25 },
        { x: 4, y: 28 },
        { x: 5, y: 21 }
      ];

      const categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
      categoryAxis.dataFields.category = 'x';

      const valueAxis = chart.yAxes.push(new am4charts.ValueAxis());

      const series = chart.series.push(new am4charts.LineSeries());
      series.dataFields.categoryX = 'x';
      series.dataFields.valueY = 'y';
      series.tooltipText = '{valueY}';
      series.strokeWidth = 2;

      chart.cursor = new am4charts.XYCursor();
    });
  }
}
